import React, { Dispatch, SetStateAction } from 'react';
import styles from './Counter.module.css';

interface CounterProps {
    value: number;
    setValue: Dispatch<SetStateAction<number>>;
    name: string;
}

const Counter = ({ value, setValue, name }: CounterProps) => {
    const maxValue = name === 'size' || name === 'price' ? 10000 : 5;

    const handleDecrement = () => {
        if (value <= 0) {
            return;
        }

        if (Number(value) >= 0 && Number(value) <= maxValue) {
            const decrementValue = name === 'baths' ? 0.5 : 1;
            setValue((prev) => +prev - decrementValue);
        }
    };

    const handleIncrement = () => {
        if (Number(value) >= 0 && Number(value) < maxValue) {
            const incrementValue = name === 'baths' ? 0.5 : 1;
            setValue(+value + incrementValue);
        }
    };

    const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
        const { value } = e.target as HTMLInputElement;

        if (Number(value) >= 0 && Number(value) <= maxValue) {
            setValue(name === 'baths' ? Math.round(Number(value) * 2) / 2 : Number(value));
        } else {
            setValue(maxValue);
        }
    };

    return (
        <div className={styles.counterWrapper}>
            <span
                className={
                    value === 0
                        ? `${styles.iconCounter} ${styles.decrement} ${styles.disable}`
                        : `${styles.iconCounter} ${styles.decrement}`
                }
                onClick={handleDecrement}>
                -
            </span>
            <input
                type="number"
                name={name}
                value={value}
                onChange={handleChange}
                onKeyDown={(e: React.KeyboardEvent<HTMLElement>) => {
                    if (['-', '+', 'e'].includes(e.key)) {
                        e.preventDefault();
                    }
                }}
            />
            <span className={`${styles.iconCounter} ${styles.increment}`} onClick={handleIncrement}>
                +
            </span>
        </div>
    );
};

export default Counter;
